import { AUTH_CONFIG } from '../config/auth.config';

export interface CrossServiceNavOptions {
  /** Path within the Vue ERP origin (e.g. '/orders/sales-orders/all'). */
  vuePath: string;
  /** Open in a new tab instead of replacing the current one. */
  openInNewTab?: boolean;
  /** Append the current location.search to the destination URL. */
  preserveQuery?: boolean;
}

/**
 * Send the user from React to a Vue ERP route.
 *
 * Auth/session is handled separately by the existing cross-origin sync
 * (Vue's auth.store iframes React's /auth-sync/ pages and vice versa) — we
 * do NOT attach tokens to URLs here, that would leak credentials into
 * browser history and server logs.
 *
 * Every user-initiated caller passes `openInNewTab: true` (aside menu, mobile
 * menu sheet, bottom tab bar, breadcrumb): a cross-origin navigation unloads
 * the React app entirely, so opening the ERP beside it keeps this tab and any
 * in-flight work alive. The flag stays opt-in rather than defaulting to true
 * because the in-tab form is still the correct behaviour for a forced redirect
 * (a dead session, for instance), where leaving the old page open would be wrong.
 */
export const navigateToVueRoute = ({
  vuePath,
  openInNewTab = false,
  preserveQuery = false,
}: CrossServiceNavOptions): void => {
  const query = preserveQuery ? window.location.search : '';
  const url = `${AUTH_CONFIG.VUE_APP_URL}${vuePath}${query}`;

  if (openInNewTab) {
    window.open(url, '_blank', 'noopener');
  } else {
    window.location.href = url;
  }
};
